import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrigamiResponse, ServiceBase } from './base/service.base';
import { Topic, TopicField } from '../utils/topic-utils';
import { map } from 'rxjs/operators';
import { ErrorCode } from '@app/origami-api/constants/error-codes';

export enum CRAReportsViewModes {
  BY_SITE = 1,
  BY_VISIT_TYPE = 3,
  BY_CRA = 2,
}

export interface GetInvestigativeSiteReports {
  // may not
  siteId: number;
  userId: number;
  viewMode: number;
  search?: any; // ?
  viewFilter: number;
  orderBy?: string;
  limit?: number;
  start?: number;
  searchClause?: string | number;
}
export interface GetInvestigativeSiteReportsResult {
  id: number;
}
export interface GetInvestigativeSiteReportResult {
  id: number;
}
export interface GetInvestigativeSiteReport {
  siteId: number;
  investigativeSiteReportTopicId: number;
}
export interface GetInvestigativeSiteReportViews {
  siteId: number;
  viewMode: CRAReportsViewModes;
  viewFilter: any; // number?
}
export interface InvestigativeSiteReportViewsResultItem {
  ViewMode: number;
  ViewFilterIdAdditional: string;
  ViewFilterId: string;
  ViewFilterDisplayName: string;
}
export interface DeleteInvestigativeSiteReport {
  siteId: number;
  investigativeSiteReports: Topic[];
}
export interface ModifyInvestigativeSiteReport {
  investigativeSiteReport: { TopicId: number; SiteId: number; TopicFields: TopicField[] };
}
export interface CreateInvestigativeSiteReport {
  investigativeSiteReport: { SiteId: number; TopicFields: TopicField[]; ReconciledTopics: Topic[] };
}
export interface ReconcileTopics {
  siteId: number;
  topics: any[];
  visitStatusId: number;
  investigativeSiteId: number;
}
export interface GetReconciledTopics {
  siteId: number;
  investigativeSiteId: number;
}

@Injectable()
export class InvestigativeSiteReportService extends ServiceBase {
  serviceUrl = 'InvestigativeSiteReportService.svc';

  getInvestigativeSiteReports(
    body: GetInvestigativeSiteReports,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ): Observable<OrigamiResponse<GetInvestigativeSiteReportsResult>> {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost('/GetInvestigativeSiteReports', body, options, silentErrorCodes, forceRequest);
  }

  getInvestigativeSiteReport(
    body: GetInvestigativeSiteReport,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ): Observable<OrigamiResponse<GetInvestigativeSiteReportResult>> {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost('/GetInvestigativeSiteReport', body, options, silentErrorCodes, forceRequest);
  }

  getInvestigativeSiteReportViews(
    body: GetInvestigativeSiteReportViews,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ): Observable<OrigamiResponse<InvestigativeSiteReportViewsResultItem[]>> {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost('/GetInvestigativeSiteReportViews', body, options, silentErrorCodes, forceRequest);
  }

  deleteInvestigativeSiteReport(
    params: DeleteInvestigativeSiteReport,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ) {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost(
      '/DeleteInvestigativeSiteReport',
      {
        siteId: params.siteId,
        investigativeSiteReports: params.investigativeSiteReports.map((topic: Topic) => {
          return {
            TopicId: topic.TopicId,
            TopicName: topic.TopicName,
          };
        }),
      },
      options,
      silentErrorCodes,
      forceRequest,
    ).pipe(map((res) => res.Result));
  }

  modifyInvestigativeSiteReport(
    params: ModifyInvestigativeSiteReport,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ): Observable<OrigamiResponse<any>> {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost('/ModifyInvestigativeSiteReport', params, options, silentErrorCodes, forceRequest);
  }

  createInvestigativeSiteReport(
    params: CreateInvestigativeSiteReport,
    options?: any,
    silentErrorCodes?: ErrorCode[],
    forceRequest?: boolean,
  ): Observable<OrigamiResponse<any>> {
    if (!silentErrorCodes || !silentErrorCodes.length) {
      silentErrorCodes = [ErrorCode.FINISHED_WITH_MINOR_ERRORS];
    }

    return this.origamiPost('/CreateInvestigativeSiteReport', params, options, silentErrorCodes, forceRequest);
  }

  reconcileTopics(params: ReconcileTopics): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/ReconcileTopics', params, null, null, true);
  }

  getReconciledTopics(body: GetReconciledTopics): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/GetReconciledTopics', body, null, null, true);
  }
}
